module.exports = __webpack_public_path__ + "img/map-02.c05ecc11.jpg";